'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DrawerFilters = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _functional = require('../utils/functional');

var _listeners = require('../utils/listeners');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var DrawerFilters = exports.DrawerFilters = function () {
  function DrawerFilters(_ref) {
    var _this = this;

    var el = _ref.el,
        context = _ref.context;
    (0, _classCallCheck3.default)(this, DrawerFilters);

    this.el = el;
    this.context = context;

    this.setupListeners();

    this.selectedFilters = this.context.getElements(this.selectors.group).map(function (el) {
      var selected = '';

      (0, _functional.getElements)(_this.selectors.button, { context: el }).forEach(function (button) {
        if (JSON.parse(button.getAttribute('aria-current'))) {
          selected = button.dataset.value;
        }
      });

      return {
        el: el,
        title: el.dataset.drawerFiltersTitle,
        selected: selected
      };
    });
  }

  (0, _createClass3.default)(DrawerFilters, [{
    key: 'setupListeners',
    value: function setupListeners() {
      this.listeners = new _listeners.Listeners();

      this.listeners.add(this.el, 'click', this.handleGroupClick.bind(this));
      this.listeners.add(this.el, 'click', this.handleSubmitClick.bind(this));
      this.listeners.add(this.el, 'click', this.handleClearClick.bind(this));
    }
  }, {
    key: 'handleGroupClick',
    value: function handleGroupClick(_ref2) {
      var target = _ref2.target;

      if (!this.hasGroup(target)) return;
      if (!this.hasButton(target)) return;

      this.handleButtonClick(this.getButton(target));
    }
  }, {
    key: 'handleSubmitClick',
    value: function handleSubmitClick(e) {
      if (!this.hasSubmit(e.target)) return;

      e.preventDefault();

      var tags = this.getSelectedFilters();
      this.dispatchEvent(tags);

      this.closeDrawer();
    }
  }, {
    key: 'handleClearClick',
    value: function handleClearClick(e) {
      if (!this.hasClear(e.target)) return;

      e.preventDefault();

      var buttons = this.getAllButtons(e.target);

      buttons.forEach(function (el) {
        el.setAttribute('aria-current', 'false');
      });

      this.selectedFilters = this.selectedFilters.map(function (selectedFilter) {
        selectedFilter.selected = 'false';
        return selectedFilter;
      });

      this.dispatchEvent([]);

      this.closeDrawer();
    }
  }, {
    key: 'handleButtonClick',
    value: function handleButtonClick(button) {
      var _this2 = this;

      var isAlreadySelected = button.getAttribute('aria-current') === 'true';

      this.getGroupButtons(button).forEach(function (el) {
        if (el === button && isAlreadySelected) {
          return el.setAttribute('aria-current', 'false');
        }
        el.setAttribute('aria-current', String(el === button));
      });

      this.selectedFilters = this.selectedFilters.map(function (selectedFilter) {
        if (selectedFilter.title === _this2.getGroup(button).dataset.drawerFiltersTitle) {
          if (selectedFilter.selected === button.dataset.value) {
            selectedFilter.selected = '';
          } else {
            selectedFilter.selected = button.dataset.value;
          }
        }

        return selectedFilter;
      });
    }
  }, {
    key: 'getSelectedFilters',
    value: function getSelectedFilters() {
      return this.selectedFilters.filter(function (selectedFilter) {
        return selectedFilter.selected !== '';
      }).map(function (selectedFilter) {
        return selectedFilter.selected;
      });
    }
  }, {
    key: 'closeDrawer',
    value: function closeDrawer() {
      window.drawers.activeDrawerKey = '';
    }
  }, {
    key: 'dispatchEvent',
    value: function dispatchEvent(tags) {
      this.el.dispatchEvent(new CustomEvent('filterChange', {
        detail: { tags: tags }
      }));
    }
  }, {
    key: 'getGroupButtons',
    value: function getGroupButtons(el) {
      return (0, _functional.getElements)(this.selectors.button, { context: this.getGroup(el) });
    }
  }, {
    key: 'getAllButtons',
    value: function getAllButtons() {
      return (0, _functional.getElements)(this.selectors.button, { context: this.el });
    }
  }, {
    key: 'getButton',
    value: function getButton(el) {
      return el.closest(this.selectors.button);
    }
  }, {
    key: 'hasButton',
    value: function hasButton(el) {
      return this.getButton(el) != null;
    }
  }, {
    key: 'getGroup',
    value: function getGroup(el) {
      return el.closest(this.selectors.group);
    }
  }, {
    key: 'hasGroup',
    value: function hasGroup(el) {
      return this.getGroup(el) != null;
    }
  }, {
    key: 'getSubmit',
    value: function getSubmit(el) {
      return el.closest(this.selectors.submit);
    }
  }, {
    key: 'hasSubmit',
    value: function hasSubmit(el) {
      return this.getSubmit(el) != null;
    }
  }, {
    key: 'getClear',
    value: function getClear(el) {
      return el.closest(this.selectors.clear);
    }
  }, {
    key: 'hasClear',
    value: function hasClear(el) {
      return this.getClear(el) != null;
    }
  }, {
    key: 'selectors',
    get: function get() {
      return {
        group: '.' + this.context.className + '_Group',
        button: '.' + this.context.className + '_Button',
        submit: '.' + this.context.className + '_Submit',
        clear: '.' + this.context.className + '_Clear'
      };
    }
  }]);
  return DrawerFilters;
}();